/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Tab_Downgrade_KeepInputs */



/**
* | output |
* | --- |
* | "Keep Current Plan" |
*
* @param {Plan_Tab_Downgrade_KeepInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_tab_downgrade_keep = /** @type {((inputs?: Plan_Tab_Downgrade_KeepInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Tab_Downgrade_KeepInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Aktuellen Plan behalten")
	return /** @type {LocalizedString} */ ("Keep Current Plan")
});